import React, { useState, useEffect } from "react";
import PageContainer from "../pages/PageContainer";
import ListSkeleton from "../Skeleton/ListSkeleton";
import { useOutletContext, useParams } from "react-router-dom";
import { cancelOrderApi, getOrder } from "../../api/user";
import { baseSymbol, instrumentName } from "../../utils/instrumentFormat";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import {
  faEdit,
  faEllipsisV,
  faTrash,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeleteOrderModal from "../Modals/deleteOrderModal";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { format } from "d3-format";
import GameSideBar from "./GameSideBar";

// function formatNumber(num) {
//   // Convert input to a number in case it's provided as a string
//   num = parseFloat(num);

//   // Determine if the number is an integer
//   if (Number.isInteger(num)) {
//     return new Intl.NumberFormat("en-US").format(num); // Format as a US number without decimals
//   } else {
//     // Check the number of decimal places
//     const decimalPlaces = (num.toString().split(".")[1] || []).length;

//     if (decimalPlaces === 1) {
//       // If there is one decimal place, format to two decimal places
//       return new Intl.NumberFormat("en-US", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       }).format(num);
//     } else {
//       // If there are two decimal places, format it with those decimals
//       return new Intl.NumberFormat("en-US", {
//         minimumFractionDigits: decimalPlaces,
//         maximumFractionDigits: decimalPlaces,
//       }).format(num);
//     }
//   }
// }

// AUG6
function formatNumber1(num, asset_type = "") {
  num = parseFloat(num);

  if (isNaN(num)) return "0";

  if (asset_type.toLowerCase() === "forex") {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 6,
      maximumFractionDigits: 6,
    }).format(num);
  }

  if (Number.isInteger(num)) {
    return new Intl.NumberFormat("en-US").format(num);
  } else {
    const decimalPlaces = (num.toString().split(".")[1] || []).length;

    if (decimalPlaces === 1) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    } else {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      }).format(num);
    }
  }
}

// Aug 7
// function formatNumber(num, asset_type = "") {
//   num = parseFloat(num);

//   if (isNaN(num)) return "0";

//     // ✅ If number has no decimal part, return as-is
//   if (Number.isInteger(num)) {
//     return num.toString();  // ← Just return the number unformatted
//   }



//   const isForex = asset_type.toLowerCase() === "forex";

//   if (num >= 1) {
//     // Always format to 2 decimal places for numbers >= 1
//     return new Intl.NumberFormat("en-US", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     }).format(num);
//   }

//   if (isForex) {
//     // For forex and num < 1
//     if (num === 0) return "0";

//     let rounded = parseFloat(num.toFixed(4));
//     if (rounded === 0) {
//       rounded = parseFloat(num.toFixed(5));
//       if (rounded === 0) {
//         rounded = parseFloat(num.toFixed(6));
//       }
//     }

//     return new Intl.NumberFormat("en-US", {
//       minimumFractionDigits: 4,
//       maximumFractionDigits: 6,
//     }).format(rounded);
//   }

//   // For non-forex and num < 1
//   if (Number.isInteger(num)) {
//     return new Intl.NumberFormat("en-US").format(num);
//   } else {
//     const decimalPlaces = (num.toString().split(".")[1] || []).length;

//     return new Intl.NumberFormat("en-US", {
//       minimumFractionDigits: decimalPlaces < 2 ? 2 : decimalPlaces,
//       maximumFractionDigits: decimalPlaces,
//     }).format(num);
//   }
// }

function formatNumber(num, asset_type = "") {
  num = parseFloat(num);

  if (isNaN(num)) return "0";

  const isForex = asset_type.toLowerCase() === "forex";

  // Case: whole number (e.g., 12345)
  if (Number.isInteger(num)) {
    return new Intl.NumberFormat("en-US").format(num); // adds comma
  }

  // Case: num >= 1
  if (num >= 1) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num); // adds comma
  }

  // Case: Forex AND num < 1
  if (isForex) {
    let rounded = parseFloat(num.toFixed(4));
    if (rounded === 0) {
      rounded = parseFloat(num.toFixed(5));
      if (rounded === 0) {
        rounded = parseFloat(num.toFixed(6));
      }
    }

    const decimalLength = rounded.toString().split(".")[1]?.length || 0;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: decimalLength,
      maximumFractionDigits: decimalLength,
    }).format(rounded); // adds comma
  }

  // Case: non-forex and < 1
  // const decimalPlaces = (num.toString().split(".")[1] || []).length;

  // return new Intl.NumberFormat("en-US", {
  //   minimumFractionDigits: decimalPlaces < 2 ? 2 : decimalPlaces,
  //   maximumFractionDigits: decimalPlaces,
  // }).format(num); // adds comma

    const decimalPlaces = (num.toString().split(".")[1] || []).length;
    //console.log(decimalPlaces, "decimalPlaces is");


    if (decimalPlaces === 1) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    } else {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      }).format(num);
    }

}


const PortfolioSection = (props) => {
  const game_id = props.gameId ?? null;
  const slug = props.slug ?? null;
  const user_id = props.user_id ?? null;
  const isSelfProfile = props.isSelfProfile ?? true;
  const ignoreDesign = props.ignoreDesign ?? false;
  // Embedded mode: rendered INSIDE another screen (a league's Portfolio tab),
  // which already owns the page container and the league navigation. Without it
  // the page carries two sets of league nav.
  const embedded = !!props.embedded;
  const Shell = embedded ? "div" : PageContainer;
  const shellProps = embedded ? {} : { gamePage: game_id && true && !ignoreDesign };

  const navigate = useNavigate();
  const isMobileView = document.body.clientWidth <= 768;
  const [openTrades, setOpenTrades] = useState([]);
  const [closedTrades, setClosedTrades] = useState([]);
  const [holdings, setHoldings] = useState([]);
  const [activeButtons, setActiveButtons] = useState("holdings");
  const [ids, setIds] = useState(0);
  const [loader, setLoader] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  // AuthLayout passes this context as an array; the Contest layout passes an
  // object. This renders under both now, and array-destructuring an object
  // throws — so read it defensively.
  const outletContext = useOutletContext();
  const sidebarToggle = Array.isArray(outletContext)
    ? outletContext[0]
    : outletContext?.sidebarToggle;
  const [dropdownStates, setDropdownStates] = useState(
    openTrades.map(() => false)
  );
  const [freeCoin, setFreeCoin] = useState("");
  const [PortfolioCoin, setPortfolioCoin] = useState("");
  const location = useLocation();
  const { traderProfile } = location.state || {};
  const { userId } = useParams();
  const isIdPresent = !!userId; // This will be true if id is present, false otherwise
  const toggleOffAllDropdowns = () => {
    setDropdownStates(openTrades.map(() => false));
  };
  useEffect(() => {
    if (activeButtons === "holdings") {
      fetchOrder(3);
    }
  }, []);

  const handleOpenTradesClick = async () => {
    setActiveButtons("openTrades");
    setButtonDropdownState(null);
    toggleOffAllDropdowns();
    await fetchOrder(1);
  };

  const toggleDropdown = (index) => {
    const newDropdownStates = [...dropdownStates];
    newDropdownStates[index] = !newDropdownStates[index];
    setDropdownStates(newDropdownStates);
  };

  const handleClosedTradesClick = async () => {
    setActiveButtons("closedTrades");
    toggleOffAllDropdowns();
    setButtonDropdownState(null);
    await fetchOrder(2);
  };

  const handleHoldingsTradesClick = async () => {
    setButtonDropdownState(null);
    setActiveButtons("holdings");
    toggleOffAllDropdowns();
    await fetchOrder(3);
  };
  const fetchOrder = async (type) => {
    try {
      setLoader(true);

      let response;
      if (userId) {
        response = await getOrder(type, userId, game_id); // Send userId to API if available
      } else {
        if(user_id){
          response = await getOrder(type, user_id, game_id);
        }else{
          response = await getOrder(type, null, game_id); // Otherwise, call the API without userId
        }
      }

      if (response?.data?.status === 200) {
        if (
          response?.data?.data?.data.length > 0 ||
          response?.data?.data?.data.length === 0
        ) {
          if (type === 1) {
            setHoldings([]);
            setOpenTrades(response?.data?.data?.data);
          } else if (type === 2) {
            setClosedTrades(response?.data?.data?.data);
          } else if (type === 3) {
            setHoldings(response?.data?.data?.data);

            if(game_id){
              setFreeCoin(
                response?.data?.data?.coin ||
                response?.data?.data?.data[0].game_free_coin
              );
            }else{
              setFreeCoin(
                response?.data?.data?.coin ||
                response?.data?.data?.data[0].free_coin
              );
            }

            if(game_id){
              setPortfolioCoin(
                response?.data?.data?.portfolio_coin ||
                  response?.data?.data?.data[0].game_portfolio_coin
              );
            }else{
              setPortfolioCoin(
                response?.data?.data?.portfolio_coin ||
                  response?.data?.data?.data[0].portfolio_coin
              );
            }
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoader(false);
    }
  };

  const formatCreatedAt = (createdAt) => {
    const currentTimeUTC = createdAt ? createdAt : moment.utc().format();
    const localTimeZone = moment.tz.guess();
    const localTime = moment
      .utc(currentTimeUTC)
      .tz(localTimeZone)
      .format("MMMM DD, YYYY hh:mm A");
    return localTime;
  };
  const formatCreatedAtHolding = (createdAt) => {
    const currentTimeUTC = createdAt ? createdAt : moment.utc().format();
    const localTimeZone = moment.tz.guess();
    const localTime = moment
      .utc(currentTimeUTC)
      .tz(localTimeZone)
      .format("MMMM DD, YYYY");
    return localTime;
  };
  const handleCancelOrder = async (id) => {
    setIds(id);
    setOpenModal(true);
  };

  const handleEditClick = async (trade) => {

    console.log("trade >>> ",trade)
    setButtonDropdownState(null);
    localStorage.setItem("trade", JSON.stringify(trade));

    if (activeButtons === "holdings") {
      localStorage.setItem("holding", "true");

      if(game_id){
        navigate(`/${slug}/buysell?from=holdings`);
      }else{
        navigate(`/buysell?from=holdings`);
      }

    } else {

      if(game_id){
        navigate(`/${slug}/buysell/${trade?.id}`);
      }else{
        navigate(`/buysell/${trade?.id}`);
      }
    }
  };

  const handleDeleteOrder = async () => {
    const res = await cancelOrderApi(ids);
    if (res?.data?.status === 200) {
      setOpenModal(false);
      if (activeButtons === "openTrades") {
        fetchOrder(1);
      } else {
        fetchOrder(2);
      }
      toast.success("Order canceled.");
    } else {
      toast.error("Could not cancel the order. Check its status and try again if it is still open.");
    }
  };

  const handleDeleteCancel = () => {
    setOpenModal(false);
  };

  const formattedCurrency = format("$,.2f")(1234567.89);
  const customFormattedCurrency = format("$,.4s")(1234567.89);
  const [buttonDropdownState, setButtonDropdownState] = useState(null);

  const toggleButtonDropdown = (currentIndex) => {
    if (buttonDropdownState === currentIndex) {
      setButtonDropdownState(null);
    } else {
      setButtonDropdownState(currentIndex);
    }
  };

  // ---------------------------------------------------------------------------
  // Mobile redesign helpers (UI-only — no functional/data changes).
  // The desktop layout below is left untouched; the mobile branch in the
  // render uses these to build the restyled Portfolio cards on one fixed grid.
  // ---------------------------------------------------------------------------
  const [expandedHoldings, setExpandedHoldings] = useState({});
  const [expandedTrades, setExpandedTrades] = useState({});
  const toggleHolding = (key) =>
    setExpandedHoldings((prev) => ({ ...prev, [key]: !prev[key] }));
  const toggleTrade = (key) =>
    setExpandedTrades((prev) => ({ ...prev, [key]: !prev[key] }));

  const usd = (n) =>
    `$${Number(n || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  const moneyInt = (n) =>
    `$${Math.round(Number(n || 0)).toLocaleString("en-US")}`;
  const qtyFmt = (q) => Number(q || 0).toLocaleString("en-US");

  // Title line via the shared instrument formatter (title-cased, parenthetical +
  // legal-suffix trimmed) — same string the Watchlist/Trade/Portfolio screens use.
  const stripCompanyName = (trade) =>
    instrumentName({ name: trade?.company_name, symbol: trade?.stock_symbol });

  // order_type: 1/5 = buy, 2 = sell, 3 = short (a short opens with a sell).
  const directionWord = (orderType) =>
    orderType === 1 || orderType === 5 ? "Buy" : "Sell";
  const positionLabel = (orderType) => (orderType === 3 ? "Short" : "Long");
  // postion_type (sic): 1 = market, 2 = limit, 3 = stop. Stored on the order at
  // creation in BuySellFunction and read back here.
  const mechanismWord = (positionType) =>
    positionType === 3 ? "stop" : positionType === 2 ? "limit" : "market";

  const fillDateTime = (d) => {
    const tz = moment.tz.guess();
    return moment
      .utc(d || moment.utc().format())
      .tz(tz)
      .format("MMM D, YYYY h:mm A");
  };

  // For a holding, pnl_amount is the current market value (total) and
  // executed_amount is the total cost basis. Gain direction flips for shorts.
  const holdingPnl = (trade) => {
    const current = parseFloat(trade?.pnl_amount) || 0;
    const cost = parseFloat(trade?.executed_amount) || 0;
    const diff = current - cost;
    return trade?.order_type === 3 ? -diff : diff;
  };
  const pnlColor = (value) =>
    value > 0 ? "#35b23c" : value < 0 ? "#e23b3b" : "#8a8b8f";
  const pnlText = (value) => `${value < 0 ? "-" : ""}${usd(Math.abs(value))}`;

  // Individual fills for a holding/trade. Uses the real `details` array when
  // present; otherwise synthesizes one fill from the row's own values
  // (correct for a single-fill position; blended for a one-row holding).
  const getFills = (trade) => {
    const details = Array.isArray(trade?.details) ? trade.details : [];
    if (details.length) {
      return [...details].sort(
        (a, b) => new Date(a.updated_at) - new Date(b.updated_at)
      );
    }
    return [
      {
        order_type: trade?.order_type,
        order_quantity: trade?.order_quantity,
        order_price: trade?.excuted_rate ?? trade?.order_price,
        updated_at: trade?.updated_at,
      },
    ];
  };

  // Avatar chip shows the BASE asset symbol only — "X:BTCUSD" -> "BTC",
  // "C:USDJPY" -> "USD", "AAPL" -> "AAPL". The full stock_symbol is still used
  // for navigation/links.
  const renderAvatar = (symbol) => (
    <div
      className="shrink-0 h-11 w-11 rounded-full flex items-center justify-center overflow-hidden"
      style={{ backgroundColor: "#004c50" }}
    >
      <span
        className="text-[11px] font-semibold leading-none px-0.5 text-center break-all"
        style={{ color: "#ffffff" }}
      >
        {baseSymbol(symbol)}
      </span>
    </div>
  );

  const renderChevron = (open) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      style={{
        transform: open ? "rotate(180deg)" : "none",
        transition: "transform .2s",
      }}
    >
      <path
        d="M6 9l6 6 6-6"
        stroke="#004c50"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const renderFillRow = (f, idx) => (
    <div key={idx} className="flex items-start justify-between py-1.5">
      <p className="text-[13px] leading-snug">
        <span className="font-semibold text-[#1a1a1a]">
          {directionWord(f.order_type)}
        </span>{" "}
        <span className="text-[#555]">
          {qtyFmt(f.order_quantity)} @ {usd(f.order_price)}
        </span>
      </p>
      <p className="text-[12px] text-[#9a9a9a] whitespace-nowrap pl-4">
        {fillDateTime(f.updated_at)}
      </p>
    </div>
  );

  return (
    <>
      <Shell {...shellProps}>
        { !embedded && slug && <GameSideBar slug={slug} activeMenu={ user_id ? "" : "portfolio"} />}
        <div>
          {loader ? (
            <ListSkeleton
              rows={5}
              avatarSize={44}
              columns={1}
              columnWidths={[80]}
              className="px-3 pt-4 max-w-4xl w-full mx-auto"
              rowClassName="py-4"
            />
          ) : (
            <div className="bg-white">
              {isMobileView ? (
                <main className="h-full bg-white">
                  <div className="tabular-nums pt-4 pb-24 px-3 max-w-4xl w-full mx-auto">
                    {/* Account summary strip — top, all tabs */}
                    {(freeCoin !== "" || PortfolioCoin !== "") && (
                      <div
                        className="rounded-xl mb-4 px-4 py-3 flex items-stretch"
                        style={{ backgroundColor: "rgba(53,178,60,0.03)" }}
                      >
                        <div className="flex-1 pr-3">
                          <p className="text-[10px] font-semibold uppercase tracking-wide text-[#6F7978]">
                            Free Cash
                          </p>
                          <p
                            className="text-[18px] font-bold leading-tight"
                            style={{ color: "#004c50" }}
                          >
                            {usd(freeCoin)}
                          </p>
                        </div>
                        <div
                          className="w-px self-stretch my-1"
                          style={{ backgroundColor: "rgba(0,76,80,0.05)" }}
                        />
                        <div className="flex-1 pl-3 text-right">
                          <p className="text-[10px] font-semibold uppercase tracking-wide text-[#6F7978]">
                            Portfolio
                          </p>
                          <p
                            className="text-[18px] font-bold leading-tight"
                            style={{ color: "#004c50" }}
                          >
                            {usd(PortfolioCoin)}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Tab pills */}
                    <div className="flex gap-2 mb-4">
                      {[
                        {
                          key: "openTrades",
                          label: "Open Orders",
                          onClick: handleOpenTradesClick,
                        },
                        {
                          key: "holdings",
                          label: "Holdings",
                          onClick: handleHoldingsTradesClick,
                        },
                        {
                          key: "closedTrades",
                          label: "Trade History",
                          onClick: handleClosedTradesClick,
                        },
                      ].map((pill) => (
                        <button
                          key={pill.key}
                          onClick={pill.onClick}
                          className={`flex-1 py-2 rounded-lg text-[12px] font-medium transition-colors ${
                            activeButtons === pill.key
                              ? "text-white"
                              : "bg-white text-[#1a1a1a] border border-gray-300"
                          }`}
                          style={
                            activeButtons === pill.key
                              ? { backgroundColor: "#004c50" }
                              : {}
                          }
                        >
                          {pill.label}
                        </button>
                      ))}
                    </div>

                    {/* ===================== OPEN ORDERS ===================== */}
                    {activeButtons === "openTrades" &&
                      (!loader && openTrades.length > 0 ? (
                        <>
                          <div className="flex items-center justify-between px-1 pb-2 mb-1 border-b border-gray-200">
                            <span className="text-[10px] font-semibold uppercase tracking-wide text-[#9a9a9a]">
                              Asset
                            </span>
                            <span className="text-[10px] font-semibold uppercase tracking-wide text-[#9a9a9a]">
                              Order Value
                            </span>
                          </div>
                          {openTrades.map((trade, index) => {
                            const showActions =
                              !userId &&
                              trade?.id != null &&
                              isSelfProfile === true;
                            const orderValue =
                              (parseFloat(trade?.order_price) || 0) *
                              (parseFloat(trade?.order_quantity) || 0);
                            return (
                              <div
                                key={index}
                                className="bg-white rounded-xl shadow-[0_1px_4px_rgba(0,0,0,0.08)] p-4 mb-3"
                              >
                                <div className="flex items-start">
                                  {renderAvatar(trade?.stock_symbol)}
                                  <div className="flex-1 ml-3 min-w-0">
                                    <div className="flex items-start">
                                      <div className="flex-1 min-w-0 pr-3">
                                        <p className="font-semibold text-[15px] text-[#1a1a1a] leading-snug break-words">
                                          {stripCompanyName(trade)}
                                        </p>
                                        <p className="text-[12px] mt-1">
                                          <span className="font-semibold text-[#1a1a1a]">
                                            {directionWord(trade?.order_type)}
                                          </span>{" "}
                                          <span className="text-[#8a8b8f] text-[11px]">
                                            {mechanismWord(trade?.postion_type)}
                                          </span>
                                        </p>
                                        <p className="text-[14px] font-semibold text-[#1a1a1a] mt-1.5">
                                          {qtyFmt(trade?.order_quantity)} @{" "}
                                          {usd(trade?.order_price)}
                                        </p>
                                      </div>
                                      <p className="shrink-0 text-[13px] text-[#8a8b8f] text-right whitespace-nowrap">
                                        {moneyInt(orderValue)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                {showActions && (
                                  <div className="border-t border-gray-100 mt-3 pt-2.5 flex items-center gap-3">
                                    <button
                                      onClick={() => handleEditClick(trade)}
                                      className="text-[13px] font-medium"
                                      style={{ color: "#006565" }}
                                    >
                                      Modify
                                    </button>
                                    <span className="text-gray-300">·</span>
                                    <button
                                      onClick={() =>
                                        handleCancelOrder(trade?.id)
                                      }
                                      className="text-[13px] font-medium"
                                      style={{ color: "#006565" }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </>
                      ) : (
                        !loader && (
                          <div className="text-center font-medium text-[#888] py-10">
                            No Data Found
                          </div>
                        )
                      ))}

                    {/* ===================== HOLDINGS ===================== */}
                    {activeButtons === "holdings" &&
                      (!loader && holdings.length > 0 ? (
                        holdings.map((trade, index) => {
                          const key = index;
                          const expanded = !!expandedHoldings[key];
                          const showActions =
                            !isIdPresent && isSelfProfile === true;
                          const current = parseFloat(trade?.pnl_amount) || 0;
                          const qty = parseFloat(trade?.order_quantity) || 0;
                          const currentPrice = qty ? current / qty : 0;
                          const marketValue = current;
                          const costBasis =
                            parseFloat(trade?.excuted_rate) || 0;
                          const pnl = holdingPnl(trade);
                          const fills = getFills(trade);
                          return (
                            <div
                              key={index}
                              className="bg-white rounded-xl shadow-[0_1px_4px_rgba(0,0,0,0.08)] p-4 mb-3"
                            >
                              <div className="flex items-start">
                                {renderAvatar(trade?.stock_symbol)}
                                <div className="flex-1 ml-3 min-w-0">
                                  <p className="font-semibold text-[15px] text-[#1a1a1a] leading-snug break-words">
                                    {stripCompanyName(trade)}
                                  </p>
                                  <p className="text-[12px] text-[#8a8b8f] mt-1">
                                    {positionLabel(trade?.order_type)}
                                  </p>
                                </div>
                                <button
                                  onClick={() => toggleHolding(key)}
                                  className="shrink-0 ml-2 p-1"
                                  aria-label="Toggle fills"
                                >
                                  {renderChevron(expanded)}
                                </button>
                              </div>

                              {/* metrics 2x2 */}
                              <div className="grid grid-cols-2 gap-y-3 gap-x-4 mt-3">
                                <div>
                                  <p className="text-[10px] uppercase tracking-wide text-[#9a9a9a] font-medium">
                                    Current Price
                                  </p>
                                  <p className="text-[15px] font-semibold text-[#1a1a1a] mt-0.5">
                                    {usd(currentPrice)}
                                  </p>
                                </div>
                                <div className="text-right">
                                  <p className="text-[10px] uppercase tracking-wide text-[#9a9a9a] font-medium">
                                    P&amp;L
                                  </p>
                                  <p
                                    className="text-[15px] font-semibold mt-0.5"
                                    style={{ color: pnlColor(pnl) }}
                                  >
                                    {pnlText(pnl)}
                                  </p>
                                </div>
                                <div>
                                  <p className="text-[10px] uppercase tracking-wide text-[#9a9a9a] font-medium">
                                    Cost Basis
                                  </p>
                                  <p className="text-[15px] font-semibold text-[#1a1a1a] mt-0.5">
                                    {usd(costBasis)}
                                  </p>
                                </div>
                                <div className="text-right">
                                  <p className="text-[10px] uppercase tracking-wide text-[#9a9a9a] font-medium">
                                    Market Value
                                  </p>
                                  <p className="text-[15px] font-semibold text-[#1a1a1a] mt-0.5">
                                    {moneyInt(marketValue)}
                                  </p>
                                </div>
                              </div>

                              {/* FILLED (expanded) */}
                              {expanded && (
                                <div className="mt-4">
                                  <p className="text-[10px] uppercase tracking-wide text-[#9a9a9a] font-semibold mb-1">
                                    Filled
                                  </p>
                                  {fills.map((f, i) => renderFillRow(f, i))}
                                </div>
                              )}

                              {/* action links */}
                              {showActions && (
                                <div className="border-t border-gray-100 mt-3 pt-2.5 flex items-center gap-3">
                                  <button
                                    onClick={() => handleEditClick(trade)}
                                    className="text-[13px] font-medium"
                                    style={{ color: "#006565" }}
                                  >
                                    Add Stop Loss
                                  </button>
                                  <span className="text-gray-300">·</span>
                                  <button
                                    onClick={() => handleEditClick(trade)}
                                    className="text-[13px] font-medium"
                                    style={{ color: "#006565" }}
                                  >
                                    Close Position
                                  </button>
                                </div>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        !loader && (
                          <div className="text-center font-medium text-[#888] py-10">
                            No Data Found
                          </div>
                        )
                      ))}

                    {/* ============ TRADE HISTORY (interim — next pass) ============ */}
                    {activeButtons === "closedTrades" &&
                      (!loader && closedTrades.length > 0 ? (
                        <>
                          <div className="flex items-center justify-between px-1 pb-2 mb-1 border-b border-gray-200">
                            <span className="text-[10px] font-semibold uppercase tracking-wide text-[#9a9a9a]">
                              Asset
                            </span>
                            <span className="text-[10px] font-semibold uppercase tracking-wide text-[#9a9a9a]">
                              Realized P&amp;L
                            </span>
                          </div>
                          {closedTrades.map((trade, index) => {
                            if (trade?.row_type === "dividend") {
                              const symbol = trade?.ticker || "DIV";
                              const shares = parseFloat(trade?.eligible_shares || 0);
                              const perShare = parseFloat(trade?.per_share_amount || 0);
                              const totalAmount = parseFloat(trade?.total_amount || 0);

                              return (
                                <div
                                  key={index}
                                  className="bg-white rounded-xl shadow-[0_1px_4px_rgba(0,0,0,0.08)] p-4 mb-3"
                                >
                                  <div className="flex items-start">
                                    {renderAvatar(symbol)}
                                    <div className="flex-1 ml-3 min-w-0">
                                      <div className="flex items-center gap-2">
                                        <p className="font-semibold text-[15px] text-[#1a1a1a] leading-snug break-words">
                                          {symbol}
                                        </p>
                                        <span
                                          className="px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide"
                                          style={{
                                            backgroundColor: "#e8f5e9",
                                            color: "#2e7d32",
                                          }}
                                        >
                                          Dividend Payout
                                        </span>
                                      </div>
                                      <p className="text-[12px] text-[#8a8b8f] mt-1">
                                        {shares.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 4 })} shares @ ${perShare.toFixed(4)} / share
                                      </p>
                                    </div>
                                    <div className="flex items-start shrink-0 ml-2">
                                      <p className="text-[14px] font-semibold text-right whitespace-nowrap text-[#35b23c]">
                                        +{usd(totalAmount)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                            const key = index;
                            const expanded = !!expandedTrades[key];
                            const realized =
                              parseFloat(trade?.pnl_amount) || 0;
                            const fills = getFills(trade);
                            return (
                              <div
                                key={index}
                                className="bg-white rounded-xl shadow-[0_1px_4px_rgba(0,0,0,0.08)] p-4 mb-3"
                              >
                                <div className="flex items-start">
                                  {renderAvatar(trade?.stock_symbol)}
                                  <div className="flex-1 ml-3 min-w-0">
                                    <p className="font-semibold text-[15px] text-[#1a1a1a] leading-snug break-words">
                                      {stripCompanyName(trade)}
                                    </p>
                                    <p className="text-[12px] text-[#8a8b8f] mt-1">
                                      {positionLabel(trade?.order_type)}
                                    </p>
                                  </div>
                                  <div className="flex items-start shrink-0 ml-2">
                                    <p
                                      className="text-[14px] font-semibold text-right whitespace-nowrap"
                                      style={{ color: pnlColor(realized) }}
                                    >
                                      {pnlText(realized)}
                                    </p>
                                    <button
                                      onClick={() => toggleTrade(key)}
                                      className="ml-2 p-1"
                                      aria-label="Toggle fills"
                                    >
                                      {renderChevron(expanded)}
                                    </button>
                                  </div>
                                </div>
                                {expanded && (
                                  <div className="border-t border-gray-100 mt-3 pt-2">
                                    <p className="text-[10px] uppercase tracking-wide text-[#9a9a9a] font-semibold mb-1">
                                      Filled
                                    </p>
                                    {fills.map((f, i) => renderFillRow(f, i))}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </>
                      ) : (
                        !loader && (
                          <div className="text-center font-medium text-[#888] py-10">
                            No Data Found
                          </div>
                        )
                      ))}
                  </div>
                </main>
              ) : (
              <main
                className={
                  isMobileView
                    ? "h-full bg-white justify-center"
                    : "h-full bg-white justify-center"
                }
              >
                <div
                  className={
                    isMobileView
                      ? `pt-4 py-3 px-3 rounded-2xl border bg-white border-white-500 max-w-4xl w-full mx-auto ${"mb-24"} `
                      : activeButtons === "holdings"
                      ? `pt-8 pb-2 px-8 rounded-xl border bg-white border-white-500 max-w-4xl w-full mx-auto mb-12`
                      : "p-8 rounded-2xl border bg-white border-white-500 max-w-4xl w-full mx-auto mb-12"
                  }
                >
                  <div className="flex justify-center space-x-4 mb-4">
                    <button
                      onClick={handleOpenTradesClick}
                      className={`px-4 py-2 rounded focus:outline-none transition-colors ${
                        activeButtons === "openTrades"
                          ? "bg-primaryColor text-white border"
                          : "bg-white text-[#8A8B8F] border"
                      } ${isMobileView && "text-xs"}`}
                    >
                      Open Orders
                    </button>
                    <button
                      onClick={handleHoldingsTradesClick}
                      className={`px-4 py-2 rounded focus:outline-none transition-colors ${
                        activeButtons === "holdings"
                          ? "bg-primaryColor text-white border"
                          : "bg-white text-[#8A8B8F]  border"
                      } ${isMobileView && "text-xs"}`}
                    >
                      Current Holdings{" "}
                    </button>
                    <button
                      onClick={handleClosedTradesClick}
                      className={`px-4 py-2 rounded focus:outline-none transition-colors ${
                        activeButtons === "closedTrades"
                          ? "bg-primaryColor text-white border"
                          : "bg-white text-[#8A8B8F] border"
                      } ${isMobileView && "text-xs"}`}
                    >
                      Closed Trades
                    </button>
                  </div>

                  {activeButtons === "openTrades" ? (
                    <>
                      {!loader && openTrades.length > 0
                        ? openTrades.map((trade, index) => (
                            <div
                              key={index}
                              className="w-full p-3 mt-4 bg-white rounded shadow-md flex items-center "
                            >
                              {/* <Link to={ slug ? `/${slug}/buysell/${trade?.stock_symbol}` : `/chartSearch/${trade?.stock_symbol}` }> */}
                                  <Link to={ slug ? `/${slug}/buysell/${trade?.stock_symbol}` : `/buysell/${trade?.stock_symbol}` }>
                                <div
                                  className={` max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] md:text-[16px] text-[10px] text-center text-white-A700 w-[83px] ${
                                    !trade?.id
                                      ? "bg-primaryColor"
                                      : trade?.order_type === 3 &&
                                        activeButtons === "openTrades" &&
                                        !trade?.id
                                      ? "bg-primaryColor"
                                      : activeButtons === "closedTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "holdings"
                                      ? "bg-primaryColor"
                                      : "bg-gray-500"
                                  }`}
                                >
                                  <span
                                    className={`text-white max-sm:break-all leading-normal ${
                                      isMobileView
                                        ? "text-[11.5px]"
                                        : "text-[13.5px]"
                                    }`}
                                  >
                                    {baseSymbol(trade?.stock_symbol)}
                                  </span>
                                </div>
                              </Link>

                              <div className="pl-3 flex flex-col">
                                {trade?.order_type === 3 ? (
                                  <p className="text-[12px] text-[#888888] font-inter md:mb-[2.2rem] mb-[1.7rem]">
                                    {trade?.order_type === 3
                                      ? "SHORT SELL"
                                      : ""}
                                  </p>
                                ) : (
                                  <p className="text-[12px] text-[#888888] font-inter  md:mb-[2.2rem] mb-[1.7rem]">
                                    {trade?.order_type === 1
                                      ? "BUY"
                                      : trade?.order_type === 5
                                      ? "BUY"
                                      : trade?.order_type === 4
                                      ? "Holdings"
                                      : "SELL"}
                                  </p>
                                )}

                                <p className="md:text-[10.5px] text-[10.5px] leading-relaxed text-[#888888] font-inter">
                                  {formatCreatedAt(trade?.updated_at)}
                                </p>

                                <p className="text-xs leading-3 text-gray-500">
                                  {trade?.action}
                                </p>
                              </div>
                              <div
                                className={
                                  isMobileView
                                    ? "flex flex-col justify-end ml-auto space-y-1"
                                    : "flex flex-col justify-end ml-auto space-y-2"
                                }
                              >
                                <div>
                                  <p
                                    className={`text-end md:text-[11px] text-[11px] font-semibold font-poppins ${
                                      trade?.order_type === 2
                                        ? "text-[#FF4B4B]"
                                        : "text-[#009D00]"
                                    }`}
                                  >
                                    $
                                    {new Intl.NumberFormat("en-US").format(
                                      trade.pnl_amount
                                    )}
                                    {/* ${trade?.pnl_amount.toLocaleString("en-US")} */}
                                    {/* {trade.pnl_amount % 1 !== 0
                                        ? Number(trade.pnl_amount).toLocaleString(
                                            "en-US",
                                            {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            }
                                          )
                                        : Number(trade.pnl_amount).toLocaleString(
                                            "en-US",
                                            {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }
                                          )} */}
                                  </p>
                                </div>
                                <div>
                                  <p className="text-end md:text-[11px] text-[11px] font-semibold  whitespace-nowrap">
                                    <span style={{ color: "#888888" }}>At</span>{" "}
                                    <span style={{ color: "#888888" }}>
                                      {" "}
                                      $
                                      {trade.order_price.toLocaleString(
                                        "en-US",
                                        {
                                          // style: "currency",
                                          // currency: "USD",
                                        }
                                      )}
                                    </span>
                                  </p>
                                </div>
                                <div>
                                  <p className="text-end md:text-[11px] text-[11px] text-[#888888] mb-[6px] md:mb-[] ">
                                    (
                                    {(trade?.order_quantity).toLocaleString(
                                      "en-US"
                                    )}
                                    )
                                  </p>
                                </div>
                              </div>
                              { (activeButtons === "openTrades" &&
                              !userId &&
                              trade?.id !== null && isSelfProfile === true ) ? (
                                <div
                                  className="ml-4"
                                  style={{ position: "relative" }}
                                >

                                  <button
                                    onClick={() => toggleDropdown(index)}
                                    type="button"
                                  >
                                    <FontAwesomeIcon
                                      icon={faEllipsisV}
                                      className=""
                                    />
                                  </button>
                                  {dropdownStates[index] && (
                                    <div className="absolute top-8 text-green-500 left-[-15px] w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                      <button
                                        onClick={() =>
                                          handleCancelOrder(trade?.id)
                                        }
                                        className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faTrash} />
                                        </div>
                                      </button>
                                      <button
                                        onClick={() => handleEditClick(trade)}
                                        className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faEdit} />
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          ))
                        : !loader && (
                            <div className="text-center font-bold text-black py-4 px-4 mt-4 mb-3">
                              <p>No Data Found</p>
                            </div>
                          )}
                    </>
                  ) : activeButtons === "closedTrades" ? (
                    <>
                      {!loader && closedTrades.length > 0
                        ? closedTrades.map((trade, index) => (
                            <div
                              key={index}
                              className="w-full p-3 mt-4 bg-white rounded shadow-md flex items-center"
                            >
                              {/* <Link to={ slug ? `/${slug}/buysell/${trade?.stock_symbol}` : `/chartSearch/${trade?.stock_symbol}` }> */}
                               <Link to={ slug ? `/${slug}/buysell/${trade?.stock_symbol}` : `/buysell/${trade?.stock_symbol}` }>
                                <div
                                  className={`max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] md:text-[16px] text-[10px] text-center text-white-A700 w-[83px] ${
                                    trade?.order_type === 3 &&
                                    activeButtons === "openTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "closedTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "holdings"
                                      ? "bg-primaryColor"
                                      : "bg-gray-500"
                                  }`}
                                >
                                  <span
                                    className={`text-white max-sm:break-all leading-normal ${
                                      isMobileView
                                        ? "text-[11.5px]"
                                        : "text-[13.5px]"
                                    }`}
                                  >
                                    {baseSymbol(trade?.stock_symbol)}
                                  </span>
                                </div>
                              </Link>

                              <div className="pl-3 flex flex-col">
                                {trade?.order_type === 3 ? (
                                  <p className="md:text-[12px] text-[12px] text-[#888888] font-inter md:mb-[2.2rem] mb-[1.7rem]">
                                    {trade?.order_type === 3
                                      ? "SHORT SELL"
                                      : ""}
                                  </p>
                                ) : (
                                  <p className="md:text-[12px] text-[12px] text-[#888888] font-inter md:mb-[2.2rem]  mb-[1.7rem]">
                                    {trade?.order_type === 1
                                      ? "BUY"
                                      : trade?.order_type === 2 ||
                                        trade?.order_type === 3
                                      ? "SELL"
                                      : trade?.order_type === 4
                                      ? "HOLDING"
                                      : trade?.order_type === 5
                                      ? "BUY"
                                      : "SELL"}
                                  </p>
                                )}

                                <p className="md:text-[10.5px] text-[10.5px] leading-relaxed text-[#888888] font-inter">
                                  {formatCreatedAt(trade?.updated_at)}
                                </p>

                                <p className="text-xs leading-3 text-gray-500">
                                  {trade?.action}
                                </p>
                              </div>
                              <div
                                className={
                                  isMobileView
                                    ? "flex flex-col justify-end ml-auto space-y-1"
                                    : "flex flex-col justify-end ml-auto space-y-2"
                                }
                              >
                                <div>
                                  <p
                                    className={`text-end md:text-[11px] text-[11px] font-semibold font-poppins ${
                                      trade?.order_type === 2
                                        ? "text-[#FF4B4B]"
                                        : "text-[#009D00]"
                                    }`}
                                  >
                                    {/* ${trade?.pnl_amount.toLocaleString("en-US")} */}
                                    ${formatNumber(trade.pnl_amount)}
                                    {/* {Number(trade.pnl_amount).toLocaleString(
                                        "en-US",
                                        {
                                          style: "currency",
                                          currency: "USD",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )} */}
                                    {/* {trade.pnl_amount % 1 !== 0
                                        ? Number(trade.pnl_amount).toLocaleString(
                                            "en-US",
                                            {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            }
                                          )
                                        : Number(trade.pnl_amount).toLocaleString(
                                            "en-US",
                                            {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }
                                          )} */}
                                    {/* ${trade?.pnl_amount.toLocaleString("en-US")} */}
                                  </p>
                                </div>
                                <div>
                                  <p className="text-end md:text-[11px] text-[11px] font-semibold  whitespace-nowraps">
                                    <span style={{ color: "#888888" }}>At</span>{" "}
                                    <span style={{ color: "#888888" }}>
                                      ${formatNumber(trade?.order_price)}
                                      {/* {trade?.order_price.toLocaleString("en-US")} */}
                                      {/* {"$"}
                                        {Number(trade?.order_price).toFixed(2)} */}
                                      {/* {Number(trade.order_price).toLocaleString(
                                          "en-US",
                                          {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )} */}
                                      {/* {trade.order_price % 1 !== 0
                                          ? Number(
                                              trade.order_price
                                            ).toLocaleString("en-US", {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })
                                          : Number(
                                              trade.order_price
                                            ).toLocaleString("en-US", {
                                              style: "currency",
                                              currency: "USD",
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            })} */}
                                    </span>
                                  </p>
                                </div>
                                <div>
                                  <p className="text-end md:text-[11px] text-[11px] text-[#888888] mb-[6px]">
                                    ({formatNumber(trade?.order_quantity)}
                                    {/* {(trade?.order_quantity).toLocaleString(
                                        "en-US"
                                      )} */}
                                    )
                                  </p>
                                </div>
                              </div>
                              { ( activeButtons === "openTrades" &&
                              trade?.id !== null && isSelfProfile  === true) ? (
                                <div
                                  className="ml-4"
                                  style={{ position: "relative" }}
                                >
                                  <button
                                    onClick={() => toggleDropdown(index)}
                                    type="button"
                                  >
                                    <FontAwesomeIcon
                                      icon={faEllipsisV}
                                      className=""
                                    />
                                  </button>
                                  {dropdownStates[index] && (
                                    <div className="absolute top-8 text-green-500 left-[-15px] w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                      <button
                                        onClick={() =>
                                          handleCancelOrder(trade?.id)
                                        }
                                        className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faTrash} />
                                        </div>
                                      </button>
                                      <button
                                        onClick={() => handleEditClick(trade)}
                                        className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faEdit} />
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          ))
                        : !loader && (
                            <div className="text-center font-bold text-black py-4 px-4 mt-4 mb-3">
                              <p>No Data Found</p>
                            </div>
                          )}
                    </>
                  ) : activeButtons === "holdings" ? (
                    <>
                      {!loader && holdings.length > 0
                        ? holdings.map((trade, index) => (
                            <div
                              key={index}
                              className="w-full p-3 mt-4 bg-white rounded shadow-md flex items-center"
                            >
                              {/* <Link to={ slug ? `/${slug}/buysell/${trade?.stock_symbol}` : `/chartSearch/${trade?.stock_symbol}` } > */}
                               <Link to={ slug ? `/${slug}/buysell/${trade?.stock_symbol}` : `/buysell/${trade?.stock_symbol}` } >
                                <div
                                  className={`max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] md:text-[16px] text-[10px] text-center text-white-A700 w-[83px] ${
                                    trade?.order_type === 3 &&
                                    activeButtons === "openTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "closedTrades"
                                      ? "bg-primaryColor"
                                      : activeButtons === "holdings"
                                      ? "bg-primaryColor"
                                      : "bg-gray-500"
                                  }`}
                                >
                                  <span
                                    className={`text-white max-sm:break-all leading-normal ${
                                      isMobileView
                                        ? "text-[11.5px]"
                                        : "text-[13.5px]"
                                    }`}
                                  >
                                    {baseSymbol(trade?.stock_symbol)}
                                  </span>
                                </div>
                              </Link>

                              <div
                                className="flex flex-col w-full ml-2"
                                style={{ gap: "4px" }}
                              >
                                <div className="grid grid-cols-2 justify-between">
                                  <div className="flex flex-col">
                                    <p className="text-[12px] text-[#888888] font-inter">
                                      {trade?.order_type === 3
                                        ? "SHORT SELL"
                                        : trade?.order_type === 1
                                        ? "BUY"
                                        : trade?.order_type === 4
                                        ? "LONG POSITION"
                                        : trade?.order_type === 5
                                        ? "BUY"
                                        : "SELL"}
                                    </p>
                                  </div>
                                  <div className="text-right">
                                    {/* <p
                                      style={{
                                        color:
                                          trade?.order_type === 3
                                            ? trade?.pnl_amount <
                                              trade?.executed_amount
                                              ? "#009D00"
                                              : "#FF4B4B"
                                            : trade?.order_type === 4
                                            ? trade?.pnl_amount <
                                              trade?.executed_amount
                                              ? "#FF4B4B"
                                              : "#009D00"
                                            : "",
                                      }}
                                      className="text-[11px] font-semibold"
                                    > */}
                                    <p
                                      style={{
                                        color:
                                          trade?.order_type === 3
                                            ? parseFloat(trade?.pnl_amount) < parseFloat(trade?.executed_amount)
                                              ? "#009D00"
                                              : "#FF4B4B"
                                            : trade?.order_type === 4
                                            ? parseFloat(trade?.pnl_amount) < parseFloat(trade?.executed_amount)
                                              ? "#FF4B4B"
                                              : "#009D00"
                                            : "",
                                      }}
                                      className="text-[11px] font-semibold"
                                    >


                                    {/* ----- */}
                                      {/* $
                                      {`${Math.abs(
                                        trade?.pnl_amount -
                                          trade?.executed_amount
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits:
                                          Math.abs(
                                            trade?.pnl_amount -
                                              trade?.executed_amount
                                          ) %
                                            1 !==
                                          0
                                            ? 2
                                            : 0,
                                        maximumFractionDigits:
                                          Math.abs(
                                            trade?.pnl_amount -
                                              trade?.executed_amount
                                          ) %
                                            1 !==
                                          0
                                            ? 2
                                            : 0,
                                      })}`} */}

                                      {/* today */}

                                      {/* $
{`${Math.abs(trade?.pnl_amount - trade?.executed_amount).toLocaleString("en-US", {
  minimumFractionDigits:
    trade?.asset_type === "forex"
      ? 6
      : Math.abs(trade?.pnl_amount - trade?.executed_amount) % 1 !== 0
      ? 2
      : 0,
  maximumFractionDigits:
    trade?.asset_type === "forex"
      ? 6
      : Math.abs(trade?.pnl_amount - trade?.executed_amount) % 1 !== 0
      ? 2
      : 0,
})}`} */}

  {/* latest */}
   $

   {/* aug 6 */}
  {/* {`${Math.abs(trade?.pnl_amount - trade?.executed_amount) === 0
  ? 0
  : Math.abs(trade?.pnl_amount - trade?.executed_amount).toLocaleString("en-US", {
      minimumFractionDigits: trade?.asset_type === "forex" ? 6 : 2,
      maximumFractionDigits: trade?.asset_type === "forex" ? 6 : 2,
    })}`} */}

    {/* aug 7 */}
    {/* ---- */}
    {(() => {
  const diff = Math.abs(trade?.pnl_amount - trade?.executed_amount);

  if (diff === 0) return "0";

  const isForex = trade?.asset_type === "forex";

  if (diff < 1) {
    let rounded = diff.toFixed(4);
    if (parseFloat(rounded) === 0) {
      rounded = diff.toFixed(5);
      if (parseFloat(rounded) === 0) {
        rounded = diff.toFixed(6);
      }
    }
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: rounded.split(".")[1].length,
      maximumFractionDigits: rounded.split(".")[1].length,
    }).format(parseFloat(rounded));
  }

  // CASE: diff >= 1 → always show 2 decimal places
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(diff);
})()}




                                    {/* --------- */}
                                      {/* $
{`${Math.abs(
  trade?.pnl_amount - trade?.executed_amount
).toLocaleString("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
})}`} */}

                                    </p>
                                  </div>
                                </div>
                                <div className="grid grid-cols-1 justify-between">
                                  <div className="flex md:flex-row flex-col justify-end text-right text-[11px] font-semibold text-[#888888]">
                                    <div className="flex md:flex-row flex-col justify-end text-right text-[11px] font-semibold text-[#888888]">
{/* ------------ */}

                                      {/* At {"$"}
                                      {trade.excuted_rate % 1 !== 0
                                        ? new Intl.NumberFormat("en-US", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(trade.excuted_rate)
                                        : new Intl.NumberFormat("en-US").format(
                                            trade.excuted_rate
                                          )}{" "}
                                      (${formatNumber(trade?.executed_amount)}) */}

                                      {/* today */}
                                      At {"$"}

                                       {/* Aug 6 */}
                                      {/* {trade.excuted_rate % 1 !== 0
                                        ? new Intl.NumberFormat("en-US", {
                                            minimumFractionDigits: trade.asset_type === "forex" ? 6 : 2,
                                            maximumFractionDigits: trade.asset_type === "forex" ? 6 : 2,
                                          }).format(trade.excuted_rate)
                                        : new Intl.NumberFormat("en-US").format(trade.excuted_rate)}{" "}
                                      (${formatNumber1(trade?.executed_amount,trade?.asset_type)}) */}

                                      {/* Aug 7 */}
                                      {/* ------------ */}
<span>
  {(() => {
    const rate = Number(trade.excuted_rate);

    if (rate === 0) return "0";

    if (rate >= 1) {
      // Always show 2 decimal places if rate is >= 1
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(rate);
    }

    if (trade.asset_type === "forex") {
      // For rate < 1 and forex
      let rounded = parseFloat(rate.toFixed(4));
      if (rounded === 0) {
        rounded = parseFloat(rate.toFixed(5));
        if (rounded === 0) {
          rounded = parseFloat(rate.toFixed(6));
        }
      }
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 4,
        maximumFractionDigits: 6,
      }).format(rounded);
    } else {
      // For non-forex and rate < 1
      return rate % 1 !== 0
        ? new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(rate)
        : new Intl.NumberFormat("en-US").format(rate);
    }
  })()}{" "}
  (${formatNumber(trade?.executed_amount, trade?.asset_type)})
</span>





{/* ---------------- */}


                                      {/* At {"$"}
{trade.excuted_rate % 1 !== 0
  ? new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 6, // allow higher precision
    }).format(trade.excuted_rate)
  : new Intl.NumberFormat("en-US").format(trade.excuted_rate)}{" "}
(${formatNumber(trade?.executed_amount)}) */}

                                    </div>
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 justify-between items-start mb-1">
                                  <div className="text-xs text-[#888888]">
                                    {activeButtons === "holdings"
                                      ? formatCreatedAtHolding(
                                          trade?.updated_at
                                        )
                                      : formatCreatedAt(trade?.created_at)}
                                  </div>
                                  <div className="text-right text-[11px] text-[#888888]">
                                    <span>
                                      ({formatNumber1(trade?.order_quantity)}
                                      {/* {(trade?.order_quantity).toLocaleString(
                                          "en-US"
                                        )} */}
                                      )
                                    </span>
                                  </div>
                                </div>
                              </div>
                              { ( activeButtons === "openTrades" &&
                              trade?.id !== null && isSelfProfile === true ) ? (
                                <div
                                  className="ml-4"
                                  style={{ position: "relative" }}
                                >
                                  <button
                                    onClick={() => toggleDropdown(index)}
                                    type="button"
                                  >
                                    <FontAwesomeIcon
                                      icon={faEllipsisV}
                                      className=""
                                    />
                                  </button>
                                  {dropdownStates[index] && (
                                    <div className="absolute top-8 left-0 z-10 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                                      <button
                                        onClick={() =>
                                          handleCancelOrder(trade?.id)
                                        }
                                        className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faTrash} />
                                        </div>
                                      </button>
                                      <button
                                        onClick={() => handleEditClick(trade)}
                                        className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faEdit} />
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                              {activeButtons === "holdings" && !isIdPresent && isSelfProfile === true ? (
                                <div
                                  className="ml-4"
                                  style={{ position: "relative" }}
                                >
                                  <button
                                    onClick={() => toggleButtonDropdown(index)}
                                    type="button"
                                  >
                                    <FontAwesomeIcon
                                      icon={faEllipsisV}
                                      className=""
                                    />
                                  </button>
                                  {buttonDropdownState === index && (
                                    <div className="absolute top-8 text-green-500 left-[-15px] w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                      <button
                                        className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                        onClick={() => handleEditClick(trade)}
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon icon={faWallet} />
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          ))
                        : !loader && (
                            <div className="text-center font-bold text-black py-4 px-4 mt-4 mb-3">
                              <p>No Data Found</p>
                            </div>
                          )}
                    </>
                  ) : (
                    ""
                  )}
                  {activeButtons === "holdings" && freeCoin  ? (
                    <div className={"flex flex-col justify-center"}>
                      <p
                        className={
                          "font-bold text-center text-primaryColor mt-4"
                        }
                      >
                        Free Cash:{" "}
                        {Number(freeCoin).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                      <span className="font-bold text-center text-primaryColor mt-2">
                        {/* {console.log(PortfolioCoin, "jsx")}
                          Portfolio: {format("$,.2f")(PortfolioCoin)} */}
                        Portfolio:{" "}
                        {Number(PortfolioCoin).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </main>
              )}
            </div>
          )}
        </div>
        <DeleteOrderModal
          isOpen={openModal}
          handleDeleteCard={handleDeleteOrder}
          handleDeleteCancel={handleDeleteCancel}
        >
          <p className="mb-4 -mt-4">
            Are you sure you want to Cancel this order?
          </p>
        </DeleteOrderModal>
      </Shell>
    </>
  );
};

export default PortfolioSection;
